import React from 'react';
import { useLocation } from 'react-router-dom';

const CompareCars = () => {
    const { state } = useLocation();
    const { chooseCars } = state;
    console.log("choose Car", chooseCars)
    return (
        <div>
            <div className="cardHeader py-4">
                <h2>Comparing Car Details</h2>
                {/* <Link to="" className="view-all-btn">View All</Link> */}
            </div>
            <table>
                <thead>
                    <tr>
                        <td>SL NO</td>
                        <td>Car Photo</td>
                        <td>Car Name</td>
                        <td>Price</td>
                        <td>Mileage</td>
                        <td>Rating</td>
                        <td>Engine</td>
                        <td>Fuel</td>
                        <td>ServiceCost</td>
                        <td>Transmission</td>
                    </tr>
                </thead>
                {
                    chooseCars.map((car, index) => (
                        <tbody>
                            <tr>
                                <td>{index + 1}</td>
                                <td style={{ width: '180px' }}><img src={car.img} style={{ width: '130px', height: '100px', borderRadius: '5px' }} alt="" /> </td>
                                <td>{car.name?.toUpperCase()}</td>
                                <td>{car.price}</td>
                                <td>{car.mileage}</td>
                                <td>{car.rating}</td>
                                <td>{car.engine}</td>
                                <td>{car.fuel}</td>
                                <td>{car.serviceCost}</td>
                                <td>{car.transmission}</td>
                            </tr>
                        </tbody>
                    ))}
            </table>
        </div>
    );
};

export default CompareCars;